import { SelectInput, type SelectOption, Switch } from '@innovationdepartment/proxima-ui';
import LoadingSpinner from 'ui/LoadingSpinner';
import PageLayoutSectionView from '../../PageSectionLayout.View';

type MasterTokenAdAccountViewProps = {
  options: SelectOption[];
  selected?: string;
  loading: boolean;
  onSwitchToggle: (toggle: boolean) => void;
  onSelectChange: (value: string) => void;
  isConnected: boolean;
};

const MasterTokenAdAccountView = ({
  options,
  loading,
  selected,
  onSwitchToggle,
  onSelectChange,
  isConnected
}: MasterTokenAdAccountViewProps) => {
  let content = (
    <SelectInput
      value={selected}
      options={options}
      placeholder="Select an ad account"
      onChange={onSelectChange}
    />
  );

  if (loading) {
    content = (
      <div style={{ height: 36 }}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <PageLayoutSectionView
      sections={[
        {
          label: 'Available ad accounts',
          content
        },
        ...(loading || !selected
          ? []
          : [
              {
                label: 'Connected',
                content: (
                  <Switch
                    key={isConnected ? 'master-token-connected' : 'master-token-disconnected'}
                    checked={isConnected}
                    onChange={(toggle: boolean) => onSwitchToggle(toggle)}
                  />
                )
              }
            ])
      ]}
    />
  );
};

export default MasterTokenAdAccountView;
